export const SHADOW_IN_USER = '@@shadowIn/signIn'

export const SAVE_SHADOW_IN_PATH = '@@shadowIn/savePath'
